module.exports = __webpack_public_path__ + "media/img/download_app_store_black@3x-c741f30a.svg";